import { memo, ElementType } from 'react';
import { Highlight } from '@page/ui';

import { useMarkdownRendererContext } from '../MarkdownRendererContextProvider';

interface MarkdownElementRendererProps {
  node?: unknown;
  children?: React.ReactNode;
}

export const createMarkdownElementRenderer = (Element: ElementType) => {
  const MarkdownElementRendererBase = ({ children, node, ...rest }: MarkdownElementRendererProps) => {
    const { highlights, matchWholeWords } = useMarkdownRendererContext((state) => state);

    if (highlights.length === 0) {
      return <Element {...rest}>{children}</Element>;
    }

    return (
      <Element {...rest}>
        <Highlight highlight={highlights} matchWholeWords={matchWholeWords}>
          {children}
        </Highlight>
      </Element>
    );
  };

  return memo(MarkdownElementRendererBase) as typeof MarkdownElementRendererBase;
};

export const MarkdownSpanRenderer = createMarkdownElementRenderer('span');
export const MarkdownLiRenderer = createMarkdownElementRenderer('li');
export const MarkdownParagraphRenderer = createMarkdownElementRenderer('p');
export const MarkdownStrongRenderer = createMarkdownElementRenderer('strong');
export const MarkdownEmRenderer = createMarkdownElementRenderer('em');
